/**
 * Provides JS functionality for tracking alert display.
 */
class TeamMember extends DrupalBehavior {
  onContent(context) {
    gsap.to($('.team-member__bio', context), {
      duration: 0.1,
      ease: 'power4.out',
      height: 0
    });
    once('TeamMember', 'html').forEach(function (element) {
      $('.team-member__bio-button').on('click', function(e) {
        $bioButton = $(this);
        $bio = $bioButton.siblings('.team-member__bio');
        $bio.toggleClass('open');
        if ($bio.hasClass('open')) {
          $bioButton.attr('aria-expanded', true);
          $bioButton.text('Hide Bio');
          gsap.to($bio, {
            duration: 0.5,
            ease: 'power4.out',
            height: 'auto'
          });
        } else {
          $bioButton.attr('aria-expanded', false);
          $bioButton.text('Show Bio');
          gsap.to($bio, {
            duration: 0.5,
            ease: 'power4.out',
            height: 0
          });
        }
      });
    });
  }

}

DrupalBehavior.register('camc.components', 'teammember', TeamMember);
